import _ from "lodash";
import React, { useState } from "react";
import { FormattedMessage as FM } from "react-intl";
import { Form, Message } from "semantic-ui-react";

import IDate from "../data/Date";
import checkDate from "../util/dateConverts/checkDate";
import BoldFM from "../util/styledMessages/BoldFM";
import ItalicFM from "../util/styledMessages/ItalicFM";
import UncertainCheckbox from "./priest-profile/priest-data-uncertain-check/UncertainCheckbox";

const regexp = /^[0-9\b]+$/;

interface IDateInputProps {
    date: IDate;
    isGrey?: boolean;
    changeDate(newDate: IDate): void;
    handleUncertainChange?: () => void;
    uncertain?: boolean;
}

const DateInput: React.FC<IDateInputProps> = (props: IDateInputProps) => {
    const { date, changeDate, isGrey, uncertain, handleUncertainChange } = props;

    const [dateIsValid, setDateIsValid] = useState(checkDate(date));

    const handleChange = (event: any) => {
        const { name, value } = event.target;

        if (name === "comment") {
            changeDate({ ...date, comment: value });
        } else if (value === "" || regexp.test(value)) {
            setDateIsValid(checkDate({ ...date, [name]: Number(value) }));
            changeDate({ ...date, [name]: Number(value) });
        }
    };

    return (
        <Form>
            <Form.Group inline style={{ marginBottom: "-2px" }} unstackable>
                <Form.Input
                    fluid
                    id={isGrey ? "grey" : ""}
                    label={<BoldFM id="label.date.year" style={isGrey ? { color: "gray" } : {}} />}
                    name="year"
                    onChange={handleChange}
                    style={{ width: "6em" }}
                    type="number"
                    value={date.year === 0 ? "" : date.year}
                />
                <Form.Input
                    fluid
                    id={isGrey ? "grey" : ""}
                    label={<BoldFM id="label.date.month" style={isGrey ? { color: "gray" } : {}} />}
                    name="month"
                    onChange={handleChange}
                    style={{ width: "5em" }}
                    type="number"
                    value={date.month === 0 ? "" : date.month}
                />
                <Form.Input
                    fluid
                    id={isGrey ? "grey" : ""}
                    label={<BoldFM id="label.date.day" style={isGrey ? { color: "gray" } : {}} />}
                    name="day"
                    onChange={handleChange}
                    style={{ width: "5em" }}
                    type="number"
                    value={date.day === 0 ? "" : date.day}
                />
                {!dateIsValid && (
                    <Form.Field
                        label={
                            <Message negative size="mini">
                                <FM id="formError.invalidDate" />
                            </Message>
                        }
                    />
                )}
                {!_.isNil(uncertain) && !_.isNil(handleUncertainChange) && (
                    <div style={{ paddingTop: "17px" }}>
                        <UncertainCheckbox handleUncertainChange={handleUncertainChange} uncertain={uncertain} />
                    </div>
                )}
            </Form.Group>
            <Form.Input
                fluid
                id={"grey"}
                label={<ItalicFM id="label.date.comment" style={{ color: "gray" }} />}
                name="comment"
                onChange={handleChange}
                value={date.comment}
            />
        </Form>
    );
};

export default DateInput;
